import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';
import { calculateTariffCostFailed, calculateTariffCostSuccessful } from '../actions';

export default function* calculateTariffCost(action) {
  try {
    const pool = action.payload;
    const url = `${BACKEND_URL}/proxy/tariff/v1/get-cost`;
    const dataResponse = yield makeRequest(url, pool, action, 'POST', true);
    const data = yield dataResponse.json();

    if (dataResponse.status === OK) {
      yield put(calculateTariffCostSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(calculateTariffCostFailed([]));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(calculateTariffCostFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
